import { Injectable } from '@angular/core'
import { EventLoggingParams, LogEvent, LogEventKey } from 'src/app/interfaces/log'
import { LogService } from '../log.service'

@Injectable({
  providedIn: 'root',
})
export class EgenTetoQuizLogService {
  constructor(private logService: LogService) {}

  // [EGEN_TETO퀴즈 - 랜딩] 화면 진입
  logEgenTetoQuizLandingPageViewed(): void {
    this.eventLogging(LogEvent.EGEN_TETO_QUIZ_LANDING_PAGE_VIEWED)
  }
  // [EGEN_TETO퀴즈 - 랜딩] 시작 버튼 클릭
  logEgenTetoQuizLandingStartButtonClicked(): void {
    this.eventLogging(LogEvent.EGEN_TETO_QUIZ_LANDING_START_BUTTON_CLICKED)
  }
  // [EGEN_TETO퀴즈 - 랜딩] - EGEN_TETO 궁금하다면 버튼 클릭
  logEgenTetoQuizLandingAboutEgen_tetoButtonClicked(): void {
    this.eventLogging(LogEvent.EGEN_TETO_QUIZ_LANDING_ABOUT_EGEN_TETO_BUTTON_CLICKED)
  }
  // [EGEN_TETO퀴즈 - 생성] 화면 진입
  logEgenTetoQuizCreationPageViewed(step: number): void {
    this.eventLogging(LogEvent.EGEN_TETO_QUIZ_CREATION_PAGE_VIEWED, { step })
  }
  // [EGEN_TETO퀴즈 - 생성] 다음 버튼 클릭
  logEgenTetoQuizCreationNextButtonClicked(step: number): void {
    this.eventLogging(LogEvent.EGEN_TETO_QUIZ_CREATION_NEXT_BUTTON_CLICKED, { step })
  }
  // [EGEN_TETO퀴즈 - 응답] 화면 진입
  logEgenTetoQuizReplyPageViewed(step: number): void {
    this.eventLogging(LogEvent.EGEN_TETO_QUIZ_REPLY_PAGE_VIEWED, { step })
  }
  // [EGEN_TETO퀴즈 - 응답] 다음 버튼 클릭
  logEgenTetoQuizReplyNextButtonClicked(step: number): void {
    this.eventLogging(LogEvent.EGEN_TETO_QUIZ_REPLY_NEXT_BUTTON_CLICKED, { step })
  }
  // [EGEN_TETO호스트퀴즈리포트] - 화면 진입
  logEgenTetoHostQuizReportPageViewed(): void {
    this.eventLogging(LogEvent.EGEN_TETO_HOST_QUIZ_REPORT_PAGE_VIEWED)
  }
  // (Web Only) [EGEN_TETO호스트퀴즈리포트] - 저장하기 클릭
  logEgenTetoHostQuizReportSaveButtonClicked(): void {
    this.eventLogging(LogEvent.EGEN_TETO_HOST_QUIZ_REPORT_SAVE_BUTTON_CLICKED)
  }
  // (Web Only) [EGEN_TETO호스트퀴즈리포트] - 타입스 앱으로 이용하기 클릭
  logEgenTetoHostQuizReportUseAppButtonClicked(): void {
    this.eventLogging(LogEvent.EGEN_TETO_HOST_QUIZ_REPORT_USE_APP_BUTTON_CLICKED)
  }
  // [EGEN_TETO호스트퀴즈리포트] - 내 테스트 결과 탭 클릭
  logEgenTetoHostQuizReportMyTestResultTabClicked(): void {
    this.eventLogging(LogEvent.EGEN_TETO_HOST_QUIZ_REPORT_MY_TEST_RESULT_TAB_CLICKED)
  }
  // [EGEN_TETO호스트퀴즈리포트] - 친구들이 보는 나 탭 클릭
  logEgenTetoHostQuizReportReplyListTabClicked(): void {
    this.eventLogging(LogEvent.EGEN_TETO_HOST_QUIZ_REPORT_REPLY_LIST_TAB_CLICKED)
  }
  // [EGEN_TETO호스트퀴즈리포트] - 민감성 유형별 요약 설명 클릭
  logEgenTetoHostQuizReportSummaryDescriptionByTypeOfSensitivityClicked(): void {
    this.eventLogging(LogEvent.EGEN_TETO_HOST_QUIZ_REPORT_SUMMARY_DESCRIPTION_BY_TYPE_OF_SENSITIVITY_CLICKED)
  }
  // [EGEN_TETO호스트퀴즈리포트] - 남들이 보는 나는 어떤지 확인하고 싶다면 클릭
  logEgenTetoHostQuizReportNavigateToReplyListButtonClicked(): void {
    this.eventLogging(LogEvent.EGEN_TETO_HOST_QUIZ_REPORT_NAVIGATE_TO_REPLY_LIST_BUTTON_CLICKED)
  }
  // [EGEN_TETO호스트퀴즈리포트] - 내 MBTI 확인하기 클릭
  logEgenTetoHostQuizReportCheckMyMbtiButtonClicked(): void {
    this.eventLogging(LogEvent.EGEN_TETO_HOST_QUIZ_REPORT_CHECK_MY_MBTI_BUTTON_CLICKED)
  }
  // [EGEN_TETO호스트퀴즈리포트] - 테스트 공유 버튼 클릭 (하단 linear 공유)
  logEgenTetoHostQuizReportShareTestButtonClicked(type: 'kakao' | 'x' | 'qr' | 'link'): void {
    this.eventLogging(LogEvent.EGEN_TETO_HOST_QUIZ_REPORT_SHARE_TEST_BUTTON_CLICKED, { type })
  }
  // [EGEN_TETO호스트퀴즈리포트] - 민감한 특징 상세 클릭 (내가 가진 민감한 특징, 다른 민감한 특징들)
  logEgenTetoHostQuizReportDetailedSensitiveFeaturesClicked(): void {
    this.eventLogging(LogEvent.EGEN_TETO_HOST_QUIZ_REPORT_DETAILED_SENSITIVE_FEATURES_CLICKED)
  }
  // [EGEN_TETO호스트퀴즈리포트] - 민감도 등급 클릭 (초초민감자, 초민감자, …)
  logEgenTetoHostQuizReportSensitivityRatingClicked(): void {
    this.eventLogging(LogEvent.EGEN_TETO_HOST_QUIZ_REPORT_SENSITIVITY_RATING_CLICKED)
  }
  // [EGEN_TETO호스트퀴즈리포트] - 퀴즈 공유하기 클릭 (상단 공유)
  logEgenTetoHostQuizReportShareQuizButtonClicked(): void {
    this.eventLogging(LogEvent.EGEN_TETO_HOST_QUIZ_REPORT_SHARE_QUIZ_BUTTON_CLICKED)
  }
  // [EGEN_TETO호스트퀴즈리포트] - 링크 복사 클릭 (상단 공유)
  logEgenTetoHostQuizReportCopyLinkButtonClicked(): void {
    this.eventLogging(LogEvent.EGEN_TETO_HOST_QUIZ_REPORT_COPY_LINK_BUTTON_CLICKED)
  }
  // [EGEN_TETO호스트퀴즈리포트] -  QR 공유 클릭 (상단 공유)
  logEgenTetoHostQuizReportQrCodeButtonClicked(): void {
    this.eventLogging(LogEvent.EGEN_TETO_HOST_QUIZ_REPORT_QR_CODE_BUTTON_CLICKED)
  }
  // [EGEN_TETO호스트퀴즈리포트] - 응답 클릭
  logEgenTetoHostQuizReportReplyClicked(): void {
    this.eventLogging(LogEvent.EGEN_TETO_HOST_QUIZ_REPORT_REPLY_CLICKED)
  }
  // [EGEN_TETO호스트퀴즈리포트] - 자세히 탐구하기 클릭
  logEgenTetoHostQuizReportInvestigateDeeplyClicked(): void {
    this.eventLogging(LogEvent.EGEN_TETO_HOST_QUIZ_REPORT_INVESTIGATE_DEEPLY_CLICKED)
  }
  // [EGEN_TETO호스트퀴즈리포트] - 소울메이트 배너 클릭
  logEgenTetoHostQuizReportSoumateBannerClicked(): void {
    this.eventLogging(LogEvent.EGEN_TETO_HOST_QUIZ_REPORT_SOULMATE_BANNER_CLICKED)
  }
  // [EGEN_TETO게스트퀴즈리포트] - 화면 진입
  logEgenTetoGuestQuizReportPageViewed(viewerType: 'host' | 'guest'): void {
    this.eventLogging(LogEvent.EGEN_TETO_GUEST_QUIZ_REPORT_PAGE_VIEWED, { viewerType })
  }
  // [EGEN_TETO게스트퀴즈리포트] - 민감도 등급 클릭 (초초민감자, 초민감자, …)
  logEgenTetoGuestQuizReportSensitivityRatingClicked(viewerType: 'host' | 'guest'): void {
    this.eventLogging(LogEvent.EGEN_TETO_GUEST_QUIZ_REPORT_SENSITIVITY_RATING_CLICKED, { viewerType })
  }
  // [EGEN_TETO게스트퀴즈리포트] - EGEN_TETO 설명 자세히 보기 클릭
  logEgenTetoGuestQuizReportViewDetailedDescriptionClicked(viewerType: 'host' | 'guest'): void {
    this.eventLogging(LogEvent.EGEN_TETO_GUEST_QUIZ_REPORT_VIEW_DETAILED_DESCRIPTION_CLICKED, { viewerType })
  }
  // [EGEN_TETO게스트퀴즈리포트] - 모든응답 page 버튼 클릭
  logEgenTetoGuestQuizReportAllReplyPageButtonClicked(viewerType: 'host' | 'guest', buttonType: 'next' | 'prev'): void {
    this.eventLogging(LogEvent.EGEN_TETO_GUEST_QUIZ_REPORT_ALL_REPLY_PAGE_BUTTON_CLICKED, { viewerType, buttonType })
  }
  // [EGEN_TETO게스트퀴즈리포트] - 민감성 유형별 설명 클릭
  logEgenTetoGuestQuizReportDescriptionByTypeOfSensitivityClicked(viewerType: 'host' | 'guest'): void {
    this.eventLogging(LogEvent.EGEN_TETO_GUEST_QUIZ_REPORT_DESCRIPTION_BY_TYPE_OF_SENSITIVITY_CLICKED, { viewerType })
  }
  // [EGEN_TETO게스트퀴즈리포트] - 내 민감도 레벨 확인하기 버튼 클릭
  logEgenTetoGuestQuizReportCheckMySensitivityLevelButtonClicked(): void {
    this.eventLogging(LogEvent.EGEN_TETO_GUEST_QUIZ_REPORT_CHECK_MY_SENSITIVITY_LEVEL_BUTTON_CLICKED)
  }
  // [EGEN_TETO설명] - 화면 진입
  logEgenTetoDescriptionPageViewed(): void {
    this.eventLogging(LogEvent.EGEN_TETO_DESCRIPTION_PAGE_VIEWED)
  }
  // [EGEN_TETO 민감한 특징들 설명] - 화면 진입
  logEgenTetoDescriptionSensitiveFeaturesPageViewed(): void {
    this.eventLogging(LogEvent.EGEN_TETO_DESCRIPTION_SENSITIVE_FEATURES_PAGE_VIEWED)
  }
  // [EGEN_TETO 민감한 특징들 설명] - 강점/약점 펼쳐보기 클릭
  logEgenTetoDescriptionSensitiveFeaturesStrengthsAndWeaknessesExpandClicked(): void {
    this.eventLogging(LogEvent.EGEN_TETO_DESCRIPTION_SENSITIVE_FEATURES_STRENGTHS_AND_WEAKNESSES_EXPAND_CLICKED)
  }
  // [EGEN_TETO 민감한 특징들 설명] - 친구에게도 이 테스트 알려주기 클릭
  logEgenTetoDescriptionSensitiveFeaturesShareTestButtonClicked(): void {
    this.eventLogging(LogEvent.EGEN_TETO_DESCRIPTION_SENSITIVE_FEATURES_SHARE_TEST_BUTTON_CLICKED)
  }
  // [EGEN_TETO 민감한 특징들 설명] - 더 구체적인 내용 탐색해보기 클릭
  logEgenTetoDescriptionSensitiveFeaturesInvestigateDeeplyClicked(): void {
    this.eventLogging(LogEvent.EGEN_TETO_DESCRIPTION_SENSITIVE_FEATURES_INVESTIGATE_DEEPLY_CLICKED)
  }

  // [EGEN_TETO 이미 푼 퀴즈 선택] - 화면 진입
  logEgenTetoQuizSelectPageViewed(): void {
    this.eventLogging(LogEvent.EGEN_TETO_QUIZ_SELECT_PAGE_VIEWED)
  }
  // [EGEN_TETO 이미 푼 퀴즈 선택] - 새로 만들기 클릭
  logEgenTetoQuizSelectCreateButtonClicked(): void {
    this.eventLogging(LogEvent.EGEN_TETO_QUIZ_SELECT_CREATE_BUTTON_CLICKED)
  }
  // [EGEN_TETO 이미 푼 퀴즈 선택] - 앱 설치 클릭
  logEgenTetoQuizSelectInstallAppButtonClicked(): void {
    this.eventLogging(LogEvent.EGEN_TETO_QUIZ_SELECT_INSTALL_APP_BUTTON_CLICKED)
  }
  // [EGEN_TETO 이미 푼 퀴즈 선택] - 결과 아이템 클릭
  logEgenTetoQuizSelectResultItemClicked(): void {
    this.eventLogging(LogEvent.EGEN_TETO_QUIZ_SELECT_RESULT_ITEM_CLICKED)
  }
  // [EGEN_TETO호스트퀴즈리포트] - 앱에서 보기 floating 버튼 클릭
  logEgenTetoHostQuizReportViewInAppFloatingButtonClicked(): void {
    this.eventLogging(LogEvent.EGEN_TETO_HOST_QUIZ_REPORT_VIEW_IN_APP_FLOATING_BUTTON_CLICKED)
  }
  // [EGEN_TETO호스트퀴즈리포트] - 로그인/앱설치 선택 모달 노출
  logEgenTetoHostQuizReportLoginOrInstallAppModalViewed(): void {
    this.eventLogging(LogEvent.EGEN_TETO_HOST_QUIZ_REPORT_LOGIN_OR_INSTALL_APP_MODAL_VIEWED)
  }
  // [EGEN_TETO호스트퀴즈리포트] - 로그인/앱설치 선택 모달 - 로그인 클릭
  logEgenTetoHostQuizReportLoginOrInstallAppModalLoginButtonClicked(): void {
    this.eventLogging(LogEvent.EGEN_TETO_HOST_QUIZ_REPORT_LOGIN_OR_INSTALL_APP_MODAL_LOGIN_BUTTON_CLICKED)
  }
  // [EGEN_TETO호스트퀴즈리포트] - 로그인/앱설치 선택 모달 - 앱 설치 클릭
  logEgenTetoHostQuizReportLoginOrInstallAppModalInstallButtonClicked(): void {
    this.eventLogging(LogEvent.EGEN_TETO_HOST_QUIZ_REPORT_LOGIN_OR_INSTALL_APP_MODAL_INSTALL_BUTTON_CLICKED)
  }
  //[Egen_teto호스트퀴즈리포트]- MBTI 통계 노출
  logEgenTetoHostQuizReportMbtiStatisticsViewed() {
    this.logService.eventLogging(LogEvent.EGEN_TETO_HOST_QUIZ_REPORT_MBTI_STATISTICS_VIEWED)
  }
  //[Egen_teto호스트퀴즈리포트]- MBTI 변경하기 버튼 클릭
  logEgenTetoHostQuizReportMbtiSelectButtonClicked() {
    this.logService.eventLogging(LogEvent.EGEN_TETO_HOST_QUIZ_REPORT_MBTI_SELECT_BUTTON_CLICKED)
  }
  //[Egen_teto Mbti 선택]- 화면 진입
  logEgenTetoMbtiSelectPageViewed() {
    this.logService.eventLogging(LogEvent.EGEN_TETO_MBTI_SELECT_PAGE_VIEWED)
  }
  //[Egen_teto Mbti 선택]- Mbti 아이템 클릭
  logEgenTetoMbtiSelectMbtiItemClicked() {
    this.logService.eventLogging(LogEvent.EGEN_TETO_MBTI_SELECT_MBTI_ITEM_CLICKED)
  }
  //[Egen_teto Mbti 선택]- Mbti 상세 결과 버튼 클릭
  logEgenTetoMbtiSelectMbtiReportButtonClicked() {
    this.logService.eventLogging(LogEvent.EGEN_TETO_MBTI_SELECT_MBTI_REPORT_BUTTON_CLICKED)
  }
  //[Egen_teto Mbti 선택] - 새로 만들기 클릭
  logEgenTetoMbtiSelectCreateNewButtonClicked() {
    this.logService.eventLogging(LogEvent.EGEN_TETO_MBTI_SELECT_CREATE_NEW_BUTTON_CLICKED)
  }
  //[Egen_teto호스트 퀴즈 리포트] - 타입스 스토리 배너 노출
  logEgenTetoHostQuizReportTypesStoryBannerViewed() {
    this.logService.eventLogging(LogEvent.EGEN_TETO_HOST_QUIZ_REPORT_TYPES_STORY_BANNER_VIEWED)
  }
  //[Egen_teto호스트 퀴즈 리포트] - 타입스 스토리 배너 편지 버튼 클릭
  logEgenTetoHostQuizReportTypesStoryBannerLetterButtonClicked() {
    this.logService.eventLogging(LogEvent.EGEN_TETO_HOST_QUIZ_REPORT_TYPES_STORY_BANNER_LETTER_BUTTON_CLICKED)
  }
  //[Egen_teto호스트 퀴즈 리포트] - 타입스 스토리 배너 노트 버튼 클릭
  logEgenTetoHostQuizReportTypesStoryBannerNoteButtonClicked() {
    this.logService.eventLogging(LogEvent.EGEN_TETO_HOST_QUIZ_REPORT_TYPES_STORY_BANNER_NOTE_BUTTON_CLICKED)
  }
  //[Egen_teto호스트퀴즈리포트] - 로그인/앱설치 선택 모달 - 앱 설치 클릭
  logEgenTetoHostQuizReportTypesStoryBannerInstallButtonClicked() {
    this.logService.eventLogging(LogEvent.EGEN_TETO_HOST_QUIZ_REPORT_TYPES_STORY_BANNER_INSTALL_BUTTON_CLICKED)
  }
  //[타입스 스토리] - 화면 진입
  logTypesStoryPageViewed() {
    this.logService.eventLogging(LogEvent.TYPES_STORY_PAGE_VIEWED)
  }
  //[타입스 스토리] - 개발자 노트 버튼 클릭
  logTypesStoryDevelopersNoteButtonClicked() {
    this.logService.eventLogging(LogEvent.TYPES_STORY_DEVELOPERS_NOTE_BUTTON_CLICKED)
  }
  //[타입스 스토리] - 앱 버튼 클릭
  logTypesStoryAppButtonClicked() {
    this.logService.eventLogging(LogEvent.TYPES_STORY_APP_BUTTON_CLICKED)
  }
  //[타입스 스토리] - 공유 버튼 클릭
  logTypesStoryShareButtonClicked(type: 'kakao' | 'qr' | 'x' | 'link') {
    this.logService.eventLogging(LogEvent.TYPES_STORY_SHARE_BUTTON_CLICKED, { type })
  }

  logEgenTetoWhitePaperSoulmateBannerClicked(): void {
    this.logService.eventLogging(LogEvent.EGEN_TETO_WHITE_PAPER_SOULMATE_BANNER_CLICKED)
  }

  logEgenTetoWhitePaperLoginOrInstallAppModalViewed(): void {
    this.logService.eventLogging(LogEvent.EGEN_TETO_WHITE_PAPER_LOGIN_OR_INSTALL_APP_MODAL_VIEWED)
  }

  logEgenTetoWhitePaperLoginOrInstallAppModalLoginButtonClicked(): void {
    this.logService.eventLogging(LogEvent.EGEN_TETO_WHITE_PAPER_LOGIN_OR_INSTALL_APP_MODAL_LOGIN_BUTTON_CLICKED)
  }
  logEgenTetoWhitePaperLoginOrInstallAppModalInstallButtonClicked(): void {
    this.logService.eventLogging(LogEvent.EGEN_TETO_WHITE_PAPER_LOGIN_OR_INSTALL_APP_MODAL_INSTALL_BUTTON_CLICKED)
  }
  logEgenTetoQueueScreenViewed(): void {
    this.logService.eventLogging(LogEvent.EGEN_TETO_QUEUE_SCREEN_VIEWED)
  }
  logEgenTetoQueueAppButtonClicked(): void {
    this.logService.eventLogging(LogEvent.EGEN_TETO_QUEUE_APP_BUTTON_CLICKED)
  }

  private eventLogging(event: LogEventKey, params?: EventLoggingParams): void {
    this.logService.eventLogging(event, {
      ...params,
    })
  }
}
